import React from 'react';
import Button from './ui/Button';
import Card from './ui/Card';
import SectionWrapper from './ui/SectionWrapper';

const pitches = [
  {
    tag: 'Feature Film',
    title: 'The Forgotten Coast',
    subtitle: 'Drama • 90 Min',
    description:
      'A fisherman’s daughter uncovers a secret buried beneath her coastal village — one that could fracture her community.',
  },
  {
    tag: 'Web Series',
    title: 'The Lost Signal',
    subtitle: 'Thriller • 6 Episodes',
    description:
      'When a satellite engineer discovers anomalous transmissions, she begins to question the origin of every signal from above.',
  },
  {
    tag: 'Documentary',
    title: 'The Last Frame',
    subtitle: 'True Events • 75 Min',
    description:
      'An intimate portrait of independent cinematographers navigating India’s rapidly changing film ecosystem.',
  },
];

export default function IdeasBackerSection({ onSignup }) {
  return (
    <SectionWrapper>
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 leading-tight">
          Ideas seeking
          <br />
          their <span className="italic text-[#C8A75B] font-medium">backer..</span>
        </h2>
        <p className="text-sm text-gray-500 max-w-xs">
          Screened, AI-verified story pitches.
          <br />
          Sign in to access the full deck.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {pitches.map((p) => (
          <Card key={p.title} className="overflow-hidden">
            <div className="bg-[#1E1F22] text-white p-4 min-h-[130px]">
              <span className="inline-block rounded-full border border-[#C8A75B]/60 px-3 py-1 text-[10px] font-semibold uppercase tracking-wide text-[#C8A75B]">
                {p.tag}
              </span>
              <p className="mt-5 text-xs text-gray-300">{p.subtitle}</p>
            </div>

            <div className="p-4">
              <h3 className="text-2xl font-bold text-gray-900">{p.title}</h3>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">{p.description}</p>

              <Button
                type="button"
                variant="outline"
                onClick={onSignup}
                className="mt-4 w-full border-gray-300 text-gray-800 hover:border-[#C8A75B]"
              >
                Sign up to view full pitch →
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
}

